export enum HtmlEvents {
    MOUSE_WHEEL = "mousewheel"
};